import { withInstall } from '/@/utils';
import CustomExportComp from './index.vue'
export const CustomExport = withInstall(CustomExportComp);